'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var KeyboardArrowLeft = {};

exports.__exports = KeyboardArrowLeft;
